import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { App } from "./App";
import { queryClient, idbPersister } from "./api/queryClient";
import { ganPerformanceObserver, ghiDiemDo } from "./core/perf";
import { RaoLoi } from "./ui/RaoLoi";

ganPerformanceObserver();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* Rào ngoài cùng: lỗi ở phần ngoài rào màn (thanh trên, dải cầu…) không làm trắng cả web — có nút xoá bộ nhớ tạm */}
    <RaoLoi toanTrang>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: idbPersister,
        buster: "h8", // h8: bỏ cache cũ của cau_suc_khoe (sai dạng gây trắng trang) · h2 (bước ghép G): gói nền thêm khối lop_nguon · h3 (F): khối chuan_tac_vu + tac_vu_tick · h4 (1b-0): lop.file_lop · h5 (0345): lop.ma_don_tuyen · h6 (0349): chuan_tac_vu.buoc + tac_vu_tick.xong / buoc_xong · h7 (0351): lop.gv_xac_nhan + giao_vien.so_dien_thoai
        // P5: HV của bộ kế hoạch (rpc_hv_bo — có tên học viên) chỉ giữ trong RAM, không lưu xuống máy.
        dehydrateOptions: { shouldDehydrateQuery: (q) => q.state.status === "success" && q.queryKey[0] !== "hv_bo" && q.queryKey[0] !== "cau_suc_khoe" },
        // cau_suc_khoe: tình trạng cầu luôn lấy mới, KHÔNG lưu IndexedDB — bản cache cũ sai dạng từng làm trắng cả web (05/11/2026).
      }}
      // buster: đổi khi dạng dữ liệu cache đổi (vd cột rpc_bootstrap) ⇒ cache cũ tự bị bỏ, tải lại cả bộ.
      // Mốc đọc xong cache IndexedDB (tính từ lúc mở trang) — K2: có cache thì bảng vẽ ngay sau mốc này.
      onSuccess={() => {
        ghiDiemDo({ man_hinh: "khoi_dong", buoc: "khoi_phuc_cache", ms: performance.now() });
        // Mở trang: có cache ⇒ vẽ ngay, nhưng LUÔN gọi delta 1 lần (cache vài giây tuổi vẫn có thể lệch — SKILL §5.2).
        void queryClient.invalidateQueries({ queryKey: ["nen"] });
      }}
    >
      <App />
    </PersistQueryClientProvider>
    </RaoLoi>
  </StrictMode>,
);
